import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import SecondaryCta from 'components/Buttons/SecondaryCta';
import FulfillmentInformation from 'components/Cart/FulfillmentInformation';

import {
  getFulfillmentDateDisplay,
  getFulfillmentTimeDisplay,
  getFormattedFulfillmentTimeRange
} from 'catering/helpers';
import {
  fulfillmentOptions,
  TITLE_BY_FULFILLMENT_METHOD
} from 'constants/fulfillmentOptions';
import { getOwnCartDrawerState } from 'styles/helpers/getSecondaryButtonState';

/**
 * Display cart details by fulfillment method
 */
const CartFulfillmentMethod = ({
  fulfillmentAddress,
  fulfillmentDateTime,
  fulfillmentTimeRange,
  fulfillmentMethod,
  onFulfillmentMethodChange
}) => {
  const isDelivery = fulfillmentOptions.DELIVERY === fulfillmentMethod;

  const fulfillmentText = isDelivery
    ? TITLE_BY_FULFILLMENT_METHOD[fulfillmentOptions.DELIVERY]
    : TITLE_BY_FULFILLMENT_METHOD[fulfillmentOptions.PICKUP];

  const fulfillmentDate = getFulfillmentDateDisplay(fulfillmentDateTime);
  const fulfillmentTime = getFulfillmentTimeDisplay(fulfillmentDateTime);

  const formattedFulfillmentTimeRange = getFormattedFulfillmentTimeRange(
    fulfillmentTimeRange
  );

  return (
    <Box data-testid="cart-fulfillment-method" width="100%" marginBottom={2}>
      <Box marginBottom={1.5}>
        <Box marginRight={2.5} display="inline">
          <FulfillmentInformation
            dataTestId="fulfillment-date"
            info={fulfillmentDate}
            onClick={onFulfillmentMethodChange}
            title={`${fulfillmentText} Date`}
          />
        </Box>
        <Box display="inline">
          <FulfillmentInformation
            dataTestId="fulfillment-time"
            info={formattedFulfillmentTimeRange ?? fulfillmentTime}
            onClick={onFulfillmentMethodChange}
            title={`${fulfillmentText} Time`}
          />
        </Box>
      </Box>
      <Box marginBottom={1.5} position="relative">
        <FulfillmentInformation
          sx={{
            maxWidth: 'none',
            whiteSpace: 'initial',
            overflow: 'unset',
            textOverflow: 'unset'
          }}
          dataTestId="fulfillment-address"
          info={fulfillmentAddress}
          onClick={onFulfillmentMethodChange}
          title={`${fulfillmentText} Address`}
        />
      </Box>
      <Box position="relative">
        <SecondaryCta
          dataTestId="fulfillment-method-change-button"
          handleClick={onFulfillmentMethodChange}
          label="Change"
          ownState={getOwnCartDrawerState()}
        />
      </Box>
    </Box>
  );
};

CartFulfillmentMethod.propTypes = {
  fulfillmentAddress: PropTypes.string.isRequired,
  fulfillmentDateTime: PropTypes.instanceOf(Date).isRequired,
  fulfillmentTimeRange: PropTypes.objectOf(PropTypes.string).isRequired,
  fulfillmentMethod: PropTypes.string.isRequired,
  onFulfillmentMethodChange: PropTypes.func.isRequired
};

export default CartFulfillmentMethod;
